import logo from "./logo.svg";
import "./App.css";
import BookAppoiment from "./pages/BookAppoiment";
import React from "react";
import AppRoutes from "./route/web";

function App() {
  return (
    <React.Fragment>
      <AppRoutes />
    </React.Fragment>
  );
}

export default App;
